import axios from "axios";
import * as types from "../mutation-types";
import _ from "lodash";
import logger from "~/utilities/logger";
import store from "~/store";

// state
export const state = {
  user_list: [],
  user_select: null,
  the_id: null,
  user_org: null,
  user_country: null,
  current_user: null,
  index_data: null,
  managed_users: [],
  planned_users: [],
  introduction: null,
};

//utils
export const getUserIndexById = (state, usrId) =>
  state.user_list.findIndex(
    (user) => user.usr_id.toString() === usrId.toString()
  );
export const getUserByUsrId = (state, usrId) =>
  state.user_list.find((user) => user.usr_id.toString() === usrId.toString());

// getters
export const getters = {
  user_list: (state) => state.user_list,
  superior_users: (state) =>
    _.orderBy(state.user_list, ["usr_surname", "usr_firstname"]),
  managed_users: (state) => state.managed_users,
  planned_users: (state) => state.planned_users,
  user_select: (state) => state.user_select,
  the_id: (state) => state.the_id,
  user_org: (state) => state.user_org,
  user_country: (state) => state.user_country,
  current_user: (state) => state.current_user,
  check_current_user: (state) => state.current_user !== null,
  check_list: (state) => state.user_list !== null && state.user_list.length > 0,
  check_managed_users: (state) =>
    state.managed_users !== null && state.managed_users.length > 0,
  check_planned_users: (state) =>
    state.planned_users !== null && state.planned_users.length > 0,
  index_data: (state) => state.index_data,
  introduction: (state) => state.introduction,
};

// mutations
export const mutations = {
  [types.FETCH_USERS](state, { user_list })
  {
    state.user_list = user_list;
  },

  [types.FETCH_MANAGED_USERS](state, { user_list })
  {
    state.managed_users = user_list;
  },

  [types.FETCH_PLANNED_USERS](state, { user_list })
  {
    state.planned_users = user_list;
  },

  [types.FETCH_USERS_FAILURE](state)
  {
    logger.error("FETCH_USERS_FAILURE");
  },

  [types.FETCH_USER](state, { user_select })
  {
    state.user_select = user_select;
  },

  [types.FETCH_USER_FAILURE](state, { error })
  {
    logger.error("FETCH_USER_FAILURE");
    logger.error(error);
  },

  [types.UPDATE_USER](state, { payload })
  {
    // state.user_select = payload.act_id;
  },

  [types.SET_USER_ID](state, { id })
  {
    state.the_id = id;
  },

  [types.SET_INTRODUCTION](state, { introduction })
  {
    state.introduction = introduction;
  },

  [types.SET_USER_COUNTRY](state, { user_country })
  {
    // logger.error(user_country);
    state.user_country = user_country;
  },

  [types.SEARCH_USERS](state, { user_list })
  {
    return (state.user_list = user_list);
  },

  [types.SELECT_USER](state, { usr_id })
  {
    const theSelect = getUserByUsrId(state, usr_id);

    logger.log("store.SELECT_USER", theSelect);

    return (state.user_select = theSelect);
  },

  [types.DESELECT_USER](state)
  {
    return (state.user_select = null);
  },

  [types.DELETE_USER](state, { usr_id })
  {
    logger.log("store.DELETE_USER", state, usr_id);

    const index = getUserIndexById(state, usr_id);

    if (index === -1)
    {
      return console.warn(`Unable to delete user (id ${usr_id})`);
    }

    return state.user_list.splice(index, 1);
  },
};

// actions
export const actions = {
  async getUsers({ commit }, payload = {})
  {
    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";
    const format = payload?.format || "minimal";

    const url = `/api/users?paginate=${paginate}&format=${format}${extraOptions}`;

    try
    {
      logger.log("store.getUsers", url);

      const { data } = await axios.get(url);

      logger.log("store.loadUsers rsp", data);

      commit(types.FETCH_USERS, { user_list: (data && data?.data) || [] });
    } catch (e)
    {
      logger.log(e);
      commit(types.FETCH_USERS_FAILURE);
    }
  },

  async getManagedUsers({ commit }, payload = {})
  {
    const usr_ids = payload?.usr_ids;
    if (!usr_ids || usr_ids.length === 0) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";
    const format = payload?.format || "minimal";

    const url = `/api/users?paginate=${paginate}&format=${format}&users=${usr_ids}${extraOptions}`;

    try
    {
      logger.log("store.getManagedUsers", url);

      const { data } = await axios.get(url);

      logger.log("store.getManagedUsers rsp", data);

      commit(types.FETCH_MANAGED_USERS, {
        user_list: (data && data?.data) || [],
      });
    } catch (e)
    {
      logger.log(e);
      commit(types.FETCH_MANAGED_USERS_FAILURE);
    }
  },

  async getPlannedUsers({ commit }, payload)
  {
    const usr_ids = payload?.usr_ids;
    if (!usr_ids || this.planned_users) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";
    const format = payload?.format || "minimal";

    const url = `/api/users?paginate=${paginate}&format=${format}&users=${usr_ids}${extraOptions}`;
    try
    {
      logger.log("store.getPlannedUsers", url);

      const { data } = await axios.get(url);

      logger.log("store.getPlannedUsers rsp", data);

      commit(types.FETCH_PLANNED_USERS, {
        user_list: (data && data?.data) || [],
      });
    } catch (e)
    {
      logger.log(e);
      commit(types.FETCH_PLANNED_USERS_FAILURE);
    }
  },

  async deleteUser({ commit, dispatch }, payload = {})
  {
    const usr_id = payload?.usr_id;

    if (!usr_id) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";
    const url = `/api/users/${usr_id}${extraOptions}`;

    try
    {
      const { data } = await axios.delete(url);

      logger.log("store.deleteUser rsp", data);

      return commit(types.DELETE_USER, { usr_id });
    } catch (e)
    {
      logger.log(e);
      return commit(types.DELETE_USER_FAILURE, { error: e });
    }
  },

  async searchUsers({ commit }, payload = {})
  {
    const query = payload?.query;
    if (!query) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";
    const url = `/api/users?search=${query}${extraOptions}`;

    try
    {
      const { data } = await axios.get(url);

      logger.log("store.searchUsers rsp", data);

      commit(types.SEARCH_USERS, { user_list: (data && data?.data) || [] });
    } catch (e)
    {
      logger.log("store.searchUsers error", e);
    }
  },

  async getUser({ commit, dispatch }, payload = {})
  {
    if (!payload?.usr_id) return;

    try
    {
      const { data } = await axios.get(`/api/users/${payload.usr_id}`);

      commit(types.FETCH_USER, { user_select: data && data?.data });

      logger.log("store.getUser", data);
    } catch (e)
    {
      logger.log(e);
      commit(types.FETCH_USER_FAILURE, { error: e });
    }
  },

  setUserID({ commit, dispatch }, id)
  {
    commit(types.SET_USER_ID, { id: id });
  },

  setIntroduction({ commit, dispatch }, introduction)
  {
    logger.log("store.setIntroduction", introduction);
    commit(types.SET_INTRODUCTION, { introduction: introduction });
  },

  async setUserCountryByLocation({ commit, dispatch }, id)
  {
    try
    {
      const { data } = await axios.get(`/api/locations/${id}`);
      logger.log("store.setUserCountryByLocation.locations", data);

      if (!data) throw "Error";
      const countryId = data?.data?.loc_country_id || null;

      if (countryId)
      {
        let countryResponse = await axios.get(`/api/countries/${countryId}`);

        //console.log('TODO - why countryResponse doesnt exist', countryResponse)
        const user_country = countryResponse && countryResponse?.data?.data;

        logger.log(
          "store.setUserCountryByLocationgetCountry.country",
          user_country
        );

        return commit(types.SET_USER_COUNTRY, {
          user_country,
        });
      }
    } catch (e)
    {
      logger.log("setUserCountryByLocation error", e);
    }
  },

  // User Feeder
  // - to name - bookging add & users
  // - get users if not user list
  // - from route organizational_units.my
  //  await store.dispatch("users/getUsers");
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
